/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { demandProposedItemSchema } from './demandProposedItemSchema';

export const demandProposedItemListSchema = z.object({
  get data() {
    return z.array(demandProposedItemSchema);
  },
});
